import React from "react";

export interface DeleteConfirmDialogProps {
  isOpen: boolean;
  alertId: number | null;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
}

export function DeleteConfirmDialog({
  isOpen,
  alertId,
  onConfirm,
  onCancel,
  isDeleting,
}: DeleteConfirmDialogProps): React.ReactElement | null {
  if (!isOpen || alertId === null) return null;

  return (
    <div
      data-testid="delete-confirm-dialog"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(41, 42, 49, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        zIndex: 999,
      }}
    >
      <div
        style={{
          backgroundColor: "var(--color-paper)",
          borderRadius: "var(--radius-card)",
          boxShadow: "var(--shadow-floating)",
          padding: "24px",
          width: "100%",
          maxWidth: "360px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>Удалить профиль?</h3>
        <p style={{ margin: 0, fontSize: "14px", color: "var(--color-slate)" }}>
          Вы уверены, что хотите удалить этот профиль? Вы перестанете получать вакансии по этим
          критериям.
        </p>

        <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
          <button
            onClick={onCancel}
            disabled={isDeleting}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "var(--radius-button)",
              backgroundColor: "var(--color-canvas)",
              color: "var(--color-graphite)",
              border: "none",
              fontWeight: 600,
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Отмена
          </button>
          <button
            data-testid="confirm-delete-btn"
            onClick={onConfirm}
            disabled={isDeleting}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "var(--radius-button)",
              backgroundColor: "var(--color-destructive)",
              color: "var(--color-paper)",
              border: "none",
              fontWeight: 600,
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            {isDeleting ? "Удаление..." : "Удалить"}
          </button>
        </div>
      </div>
    </div>
  );
}
